import { Grid, Paper } from "@mui/material";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  Polyline,
  useLoadScript,
} from "@react-google-maps/api";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import retailing from "../../Images/retailing.png";
import {
  showLoador,
  showNotification,
} from "../../Pages/Landing/Landing.slice";
import { getTimeLineForBelowSalesTeamsAndDates } from "../../Slice/managerLogs.slice";
import { serverMsg, noInternetMsg } from "../../config/messageconstant";
import newUsers from "../../Images/newUsers.png";
import { ButtonCompo } from "../../components/Comman/Button";
import uniqueUser from "../../Images/uniqueUser.png";

dayjs.extend(duration);

const GMapNew = ({
  showLoador,
  showNotification,
  getTimeLineForBelowSalesTeamsAndDates,
  mainHeight = "90vh",
  mapHeight = "100%",
  showBackBtn = true,
}) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyDvKXkZ-S03qxR-8b8HLnCOKr36eYRxC2k",
  });

  const params = useParams();
  const [mapRef, setMapRef] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [checkInLat, setCheckInLat] = useState(22.9447827);
  const [checkInLong, setCheckInLong] = useState(72.6682403);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [selectedDot, setSelectedDot] = useState(null);
  const [selectedPath, setSelectedPath] = useState([]);
  const [openInfoWindows, setOpenInfoWindows] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoaded) {
      fetchInitialMapData();
    }
  }, [isLoaded]);

  useEffect(() => {
    let grow = true;
    const interval = setInterval(() => {
      setMarkers((prev) =>
        prev.map((m) => {
          const isMain = m.icon === uniqueUser;
          return {
            ...m,
            scaledSize: grow
              ? new window.google.maps.Size(isMain ? 80 : 70, isMain ? 80 : 70)
              : new window.google.maps.Size(isMain ? 65 : 55, isMain ? 65 : 55),
            icon: m.icon,
          };
        })
      );
      grow = !grow;
    }, 700);
    return () => clearInterval(interval);
  }, []);

  const fetchInitialMapData = async () => {
    if (!navigator.onLine) {
      showNotification({ msg: noInternetMsg, severity: "error" });
      return;
    }

    const isShowTimelineMapStoppage = localStorage.getItem(
      "isShowTimelineMapStoppage"
    );

    showLoador({ loador: true });

    const salesTeamId = "6d6d698a-8710-4493-b267-c4622cc2d8c1";

    await getTimeLineForBelowSalesTeamsAndDates({
      fromDate: "29-08-2025",
      toDate: "29-08-2025",
      salesTeamId: salesTeamId,
      flag: 1,
    }).then(({ response, success }) => {
      showLoador({ loador: false });

      if (!success || !response) {
        showNotification({ msg: serverMsg, severity: "error" });
        return;
      }

      let allMarkers = [];

      response.map((salesPerson) => {
        if (
          salesPerson.managerLogsList &&
          salesPerson.managerLogsList.length > 0
        ) {
          const latestLog =
            salesPerson.managerLogsList[salesPerson.managerLogsList.length - 1];

          const lat = parseFloat(
            latestLog.managerEndLat || latestLog.managerStartLat
          );
          const lng = parseFloat(
            latestLog.managerEndLong || latestLog.managerStartLong
          );

          if (!isNaN(lat) && !isNaN(lng)) {
            allMarkers.push({
              id: salesPerson.id,
              name: salesPerson.name,
              lat,
              lng,
              logs: salesPerson.managerLogsList,
              icon: salesPerson.id == salesTeamId ? uniqueUser : newUsers,
            });
          }
        }
      });

      setMarkers(allMarkers);

      setOpenInfoWindows(allMarkers.map((m) => m.id));

      if (allMarkers.length > 0 && mapRef) {
        const bounds = new window.google.maps.LatLngBounds();
        allMarkers.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
        mapRef.fitBounds(bounds);

        setCheckInLat(allMarkers[0].lat);
        setCheckInLong(allMarkers[0].lng);

        handleMarkerClick(allMarkers[0]);
      }
    });
  };

  const onMapLoad = (map) => {
    setMapRef(map);

    if (markers.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();
      markers.map(({ lat, lng }) => bounds.extend({ lat, lng }));
      map.fitBounds(bounds);

      if (!selectedMarker) {
        handleMarkerClick(markers[0]);
      }
    } else {
      map.setCenter({ lat: checkInLat, lng: checkInLong });
      map.setZoom(6);
    }
  };

  const goBack = () => {
    navigate(-1);
  };

  const handleMarkerClick = (marker) => {
    if (selectedMarker && selectedMarker.id === marker.id) {
      setSelectedMarker(null);
      setSelectedPath([]);
      setSelectedDot(null);
      return;
    }

    if (!marker.logs || marker.logs.length === 0) return;

    const sortedLogs = [...marker.logs].sort(
      (a, b) =>
        dayjs(a.insertTime, "DD-MM-YYYY HH:mm:ss") -
        dayjs(b.insertTime, "DD-MM-YYYY HH:mm:ss")
    );

    let pathCoords = sortedLogs
      .map((log) => {
        const lat =
          log.checkInOut === 1
            ? parseFloat(log.managerEndLat)
            : parseFloat(log.managerStartLat);
        const lng =
          log.checkInOut === 1
            ? parseFloat(log.managerEndLong)
            : parseFloat(log.managerStartLong);

        if (!isNaN(lat) && !isNaN(lng)) {
          return {
            lat,
            lng,
            flag: log.flag,
            insertTime: dayjs(log.insertDateTime, "DD-MM-YYYY HH:mm:ss").format(
              "HH:mm:ss"
            ),
          };
        }
        return null;
      })
      .filter(Boolean);

    pathCoords = pathCoords.map((point, i, arr) => {
      if (i > 0) {
        const start = dayjs(arr[i - 1].insertTime, "HH:mm:ss");
        const end = dayjs(point.insertTime, "HH:mm:ss");
        const diffMinutes = dayjs.duration(end.diff(start)).asMinutes();
        return {
          ...point,
          gapTime: diffMinutes,
          isGap: diffMinutes > 15,
          prevTime: arr[i - 1].insertTime,
        };
      }
      return point;
    });

    setSelectedMarker(marker);
    setSelectedPath(pathCoords);

    setOpenInfoWindows((prev) =>
      prev.includes(marker.id) ? prev : [...prev, marker.id]
    );
  };

  const getTimeBetweenCords = (path) => {
    let stoppageObj = {};

    const isShowTimelineMapStoppage = localStorage.getItem(
      "isShowTimelineMapStoppage"
    );
    stoppageObj = isShowTimelineMapStoppage
      ? JSON.parse(isShowTimelineMapStoppage)
      : {};

    const stopMin = (stoppageObj?.stoptime || 0) / 60;

    return path.slice(0, -1).map((point, i) => {
      const next = path[i + 1];

      const start = dayjs(point.insertTime, "HH:mm:ss");
      const end = dayjs(next.insertTime, "HH:mm:ss");
      const diffMinutes = dayjs.duration(end.diff(start)).asMinutes();

      let color = "blue";
      let showGap = false;

      if (stoppageObj.identify_stops == true) {
        if (
          (stoppageObj.withActivity || (point.flag == 0 && next.flag == 0)) &&
          diffMinutes > stopMin
        ) {
          color = "red";
          showGap = true;
        }
      }

      return {
        coords: [point, next],
        color,
        showGap,
        gapTime: diffMinutes,
        gapLocation: next,
      };
    });
  };

  return (
    <Paper sx={{ borderRadius: 2, p: 1, height: mainHeight }}>
      <Grid container spacing={2} sx={{ height: "100%" }}>
        {/* Map Section */}

        <Grid item xs={12} sx={{ height: "100%" }}>
          {!isLoaded ? (
            <h1>Loading...</h1>
          ) : (
            <GoogleMap
              mapContainerStyle={{
                width: "100%",
                height: mapHeight,
                position: "relative",
              }}
              onLoad={onMapLoad}
              // center={{ lat: checkInLat, lng: checkInLong }}
              // zoom={6}
            >
              {showBackBtn ? (
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "55px",
                    zIndex: 1000,
                    backgroundColor: "white",
                  }}
                >
                  <ButtonCompo
                    size="small"
                    type="button"
                    variant="outlined"
                    name=" Back"
                    onClick={goBack}
                  />
                </div>
              ) : null}
              {markers.map((marker) => (
                <Marker
                  key={marker.id}
                  position={{ lat: marker.lat, lng: marker.lng }}
                  icon={{
                    url: marker.icon,
                    scaledSize:
                      marker.scaledSize || new window.google.maps.Size(40, 40),
                  }}
                  onClick={() => handleMarkerClick(marker)}
                >
                  {openInfoWindows.includes(marker.id) && (
                    <InfoWindow
                      position={{ lat: marker.lat, lng: marker.lng }}
                      onCloseClick={() =>
                        setOpenInfoWindows((prev) =>
                          prev.filter((id) => id !== marker.id)
                        )
                      }
                    >
                      <div>
                        <strong>{marker.name}</strong>
                        <br />
                        <strong>Time:</strong>{" "}
                        {
                          [...marker.logs].map((log) =>
                            dayjs(
                              log.insertDateTime,
                              "DD-MM-YYYY HH:mm:ss"
                            ).format("HH:mm:ss")
                          )[marker.logs.length - 1]
                        }
                      </div>
                    </InfoWindow>
                  )}
                </Marker>
              ))}

              {selectedPath.length > 1 &&
                getTimeBetweenCords(selectedPath).map((seg, id) => (
                  <Polyline
                    key={id}
                    path={seg.coords}
                    options={{
                      strokeColor: seg.color,
                      strokeOpacity: 0.8,
                      strokeWeight: 3,
                      icons: [
                        {
                          icon: {
                            path: window.google.maps.SymbolPath
                              .FORWARD_CLOSED_ARROW,
                            scale: 3,
                            strokeColor: "black",
                            strokeWeight: 2,
                          },
                          offset: "100%",
                          repeat: "50px",
                        },
                      ],
                    }}
                  />
                ))}

              {selectedPath.map((point, id) => (
                <Marker
                  key={id}
                  position={{ lat: point.lat, lng: point.lng }}
                  icon={
                    id === 0
                      ? {
                          url: retailing,
                          scaledSize: new window.google.maps.Size(40, 40),
                        }
                      : {
                          path: window.google.maps.SymbolPath.CIRCLE,
                          scale: 5,
                          fillColor: "white",
                          fillOpacity: 1,
                          strokeColor: "black",
                          strokeWeight: 1,
                        }
                  }
                  onClick={() => setSelectedDot(point)}
                />
              ))}

              {selectedDot && (
                <InfoWindow
                  position={{ lat: selectedDot.lat, lng: selectedDot.lng }}
                  onCloseClick={() => setSelectedDot(null)}
                >
                  <div>
                    {selectedDot.isGap ? (
                      <>
                        <strong>Time Delay:</strong>{" "}
                        {Math.round(selectedDot.gapTime)} mins from Last
                        Location
                        <br />
                        <strong>Time:</strong> {selectedDot.insertTime}
                      </>
                    ) : (
                      <>
                        <strong>Time:</strong> {selectedDot.insertTime}
                      </>
                    )}
                  </div>
                </InfoWindow>
              )}

              {selectedPath
                .filter((point) => point.isGap)
                .map((point, index) => (
                  <InfoWindow
                    key={index}
                    position={{ lat: point.lat, lng: point.lng }}
                    onCloseClick={() => setSelectedDot(null)}
                  >
                    <div>
                      <strong>Time Delay:</strong> {Math.round(point.gapTime)}{" "}
                      mins from Last Location
                      <br />
                      <strong>Time:</strong> {point.insertTime}
                    </div>
                  </InfoWindow>
                ))}
            </GoogleMap>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};

const mapStateToProps = (state) => ({
  location: state.location,
});

const mapDispatchToProps = {
  showLoador,
  showNotification,
  getTimeLineForBelowSalesTeamsAndDates,
};

export default connect(mapStateToProps, mapDispatchToProps)(GMapNew);
